import { IContent } from "@kunduz/data-access-cms-api";
import Link from "next/link";
import { DesktopNavMenu } from "@kunduz/ui-components";
import { getCmsIcon } from "../static/iconMappings";
import { trackEventNext } from "@kunduz/utility-analytics";
import styles from "./cmsDesktopNavItems.module.scss";

export const CmsDesktopNavItems = (props: {
  iconColor: string;
  cmsData?: IContent.HeaderItemsResponse["components"];
}) => {
  const result: any[] = [];
  if (!props.cmsData) return result;

  function handleButtonClicked(label?: string) {
    trackEventNext({
      event: "Navbar Button Clicked",
      label,
    });
  }

  for (let i = 0; i < props.cmsData.length; i++) {
    const component = props.cmsData[i];

    const Icon = component.data.icon
      ? getCmsIcon(component.data.icon)
      : undefined;

    switch (component.type) {
      case "headerbuttoncomponent":
        switch (component.data.type) {
          case "gradient":
            result.push(
              <Link
                key={`desktop_${component.data.label}`}
                href={component.data.url || "#"}
                className={styles.gradientButton}
                target={component.data.target || "_self"}
                onClick={() => handleButtonClicked(component.data.label)}
              >
                {component.data.label}
              </Link>,
            );
            break;
          case "primary":
            result.push(
              <Link
                key={`desktop_${component.data.label}`}
                href={component.data.url || "#"}
                className={styles.primaryButton}
                target={component.data.target || "_self"}
                onClick={() => handleButtonClicked(component.data.label)}
              >
                {component.data.icon ? <Icon viewBox="0 0 24 24" /> : undefined}
                {component.data.label}
              </Link>,
            );
            break;
          case "secondary":
            result.push(
              <Link
                key={`desktop_${component.data.label}`}
                href={component.data.url || "#"}
                className={styles.secondaryButton}
                target={component.data.target || "_self"}
                onClick={() => handleButtonClicked(component.data.label)}
              >
                {component.data.icon ? <Icon viewBox="0 0 24 24" /> : undefined}
                {component.data.label}
              </Link>,
            );
            break;
          case "link":
            result.push(
              <Link
                key={`desktop_${component.data.label}`}
                href={component.data.url || "#"}
                className={styles.linkButton}
                target={component.data.target || "_self"}
                onClick={() => handleButtonClicked(component.data.label)}
              >
                {component.data.icon ? <Icon viewBox="0 0 24 24" /> : undefined}
                {component.data.label}
              </Link>,
            );
            break;
          case "tertiary":
            result.push(
              <Link
                key={`desktop_${component.data.label}`}
                href={component.data.url || "#"}
                className={styles.tertiaryButton}
                target={component.data.target || "_self"}
                onClick={() => handleButtonClicked(component.data.label)}
              >
                {component.data.icon ? <Icon viewBox="0 0 24 24" /> : undefined}
                {component.data.label}
              </Link>,
            );
            break;
          default:
            break;
        }
        break;

      case "headermenucomponent":
        result.push(
          <DesktopNavMenu
            key={i}
            menus={[
              {
                title: component.data.title || "",
                items: component.data.childs?.map((child) => {
                  const MenuIcon = child.icon
                    ? getCmsIcon(child.icon)
                    : undefined;

                  return {
                    title: child.title,
                    url: child.url || "#",
                    desc: child.description,
                    icon: child.icon ? (
                      <MenuIcon color={props.iconColor} />
                    ) : undefined,
                    badgeText: child.badge_text,
                    badgeColor: child.badge_type,
                    onClick: () => handleButtonClicked(child.title),
                  };
                }) as any,
                type: component.data.type as any,
              },
            ]}
          />,
        );
        break;

      default:
        break;
    }
  }

  return result;
};
